import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 2.66666H5.6C6.23652 2.66666 6.84697 2.9164 7.29706 3.36093C7.74714 3.80546 8 4.40837 8 5.03703V13.3333C8 12.8618 7.81036 12.4096 7.47279 12.0763C7.13523 11.7429 6.67739 11.5556 6.2 11.5556H2V2.66666Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2.66666H10.4C9.76348 2.66666 9.15303 2.9164 8.70294 3.36093C8.25286 3.80546 8 4.40837 8 5.03703V13.3333C8 12.8618 8.18964 12.4096 8.52721 12.0763C8.86477 11.7429 9.32261 11.5556 9.8 11.5556H14V2.66666Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  default: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 4H8.4C9.35478 4 10.2705 4.3746 10.9456 5.0414C11.6207 5.70819 12 6.61256 12 7.55556V20C12 19.2928 11.7155 18.6145 11.2092 18.1144C10.7028 17.6143 10.0161 17.3333 9.3 17.3333H3V4Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 4H15.6C14.6452 4 13.7295 4.3746 13.0544 5.0414C12.3793 5.70819 12 6.61256 12 7.55556V20C12 19.2928 12.2845 18.6145 12.7908 18.1144C13.2972 17.6143 13.9839 17.3333 14.7 17.3333H21V4Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 5.33334H11.2C12.473 5.33334 13.6939 5.83281 14.5941 6.72187C15.4943 7.61093 16 8.81675 16 10.0741V26.6667C16 25.7237 15.6207 24.8193 14.9456 24.1525C14.2705 23.4857 13.3548 23.1111 12.4 23.1111H4V5.33334Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 5.33334H20.8C19.527 5.33334 18.3061 5.83281 17.4059 6.72187C16.5057 7.61093 16 8.81675 16 10.0741V26.6667C16 25.7237 16.3793 24.8193 17.0544 24.1525C17.7295 23.4857 18.6452 23.1111 19.6 23.1111H28V5.33334Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

function BookOpenIcon(props: SvgIconProps) {
  const item = size[(props.fontSize as "small" | "large") || "default"];

  return <SvgIcon {...props}>{item}</SvgIcon>;
}
export default BookOpenIcon;
